import { UpdatePage } from '@components/molecules';
import {
  TextFieldElement,
  SwitchElement,
  useForm,
  UseFormSetValue,
  AutocompleteElement,
} from 'react-hook-form-mui';
import API from '@apps/localization/services/division';
import { ModelProps } from '@/types';
import {
  DivisionSchema,
  DivisionSchemaType,
} from '@apps/localization/schemas/division';
import { Fragment, JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import { setDefaultLanguageValues } from '../../services/utils';
import { LANGUAGES_AVAILABLE } from '@/const';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const defaultValues = {
    translations: LANGUAGES_AVAILABLE.map((lang, idx) => ({
      language_code: {
        id: lang.id,
        label: lang.label,
      },
      inlineIndex: idx,
    })),
    is_active: true,
  };
  const formContext = useForm<DivisionSchemaType>({
    resolver: zodResolver(DivisionSchema),
    defaultValues: defaultValues,
  });

  return (
    <UpdatePage
      schema={DivisionSchema}
      api={API}
      title={t('Identified Area')}
      modelProps={modelProps}
      formcontext={formContext}
      setChildValues={(setValue) => {
        setDefaultLanguageValues(
          setValue as UseFormSetValue<DivisionSchemaType>,
        );
        (setValue as UseFormSetValue<DivisionSchemaType>)('is_active', true);
      }}
      canSaveAndContinue
    >
      <>
        <Grid container sx={{ padding: 2 }} spacing={2}>
          {LANGUAGES_AVAILABLE.map((_item, idx) => (
            <Fragment key={idx}>
              <TextFieldElement
                name={`translations.${idx}.inlineIndex`}
                value={idx}
                type="hidden"
                sx={{ display: 'none' }}
              />

              <Grid size={{ xs: 12, md: 6 }}>
                <AutocompleteElement
                  name={`translations.${idx}.language_code`}
                  label={t('Language')}
                  options={LANGUAGES_AVAILABLE}
                  required
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldElement
                  name={`translations.${idx}.name`}
                  label={t('Name')}
                  fullWidth
                  required
                />
              </Grid>
            </Fragment>
          ))}
        </Grid>
        <Grid container sx={{ padding: 2 }} spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <SwitchElement name="is_active" label={t('Is Active?')} />
          </Grid>
        </Grid>
      </>
    </UpdatePage>
  );
}
